// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-flow__node.selectable:hover .node,
.react-flow__node.draggable:hover .node {
  
}

.react-flow__node.selected .node,
.react-flow__node.selectable:focus .node,
.react-flow__node.selectable:focus-visible .node,
.react-flow__node.draggable:focus .node,
.react-flow__node.draggable:focus-visible .node {
  /* box-shadow: 0px 0px 0px 1px theme("colors.violet.700"), 0px 0px 0px 4px #7130D61F !important; */
}

.react-flow__node-placeholder {
  pointer-events: none !important;
}

.drawer {
  box-shadow:
    0px 4px 6px -1px #0000001a,
    0px 2px 4px -2px #0000001a;
}
.fade-in-right {
  opacity: 0;
  transform: translateX(100%);
  transition:
    opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
}

.fade-in-right-active {
  opacity: 1;
  transform: translateX(0);
}

/* Scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: #CCD5E0 transparent;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
  border: 0;
}

*::-webkit-scrollbar-thumb {
  background-color: #CCD5E0;
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: content-box;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #CCD5E0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/flow/styles.css"],"names":[],"mappings":"AAAA;;;AAGA;;AAEA;;;;;EAKE,kGAAkG;AACpG;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;;8BAE4B;AAC9B;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B;;8BAE4B;AAC9B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".react-flow__node.selectable:hover .node,\n.react-flow__node.draggable:hover .node {\n  \n}\n\n.react-flow__node.selected .node,\n.react-flow__node.selectable:focus .node,\n.react-flow__node.selectable:focus-visible .node,\n.react-flow__node.draggable:focus .node,\n.react-flow__node.draggable:focus-visible .node {\n  /* box-shadow: 0px 0px 0px 1px theme(\"colors.violet.700\"), 0px 0px 0px 4px #7130D61F !important; */\n}\n\n.react-flow__node-placeholder {\n  pointer-events: none !important;\n}\n\n.drawer {\n  box-shadow:\n    0px 4px 6px -1px #0000001a,\n    0px 2px 4px -2px #0000001a;\n}\n.fade-in-right {\n  opacity: 0;\n  transform: translateX(100%);\n  transition:\n    opacity 0.3s ease-in-out,\n    transform 0.3s ease-in-out;\n}\n\n.fade-in-right-active {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* Scrollbar */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #CCD5E0 transparent;\n}\n\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n  border: 0;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #CCD5E0;\n  border-radius: 4px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #CCD5E0;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
